import { render, staticRenderFns } from "./ProWhy3.vue?vue&type=template&id=2c40aa22&scoped=true&"
import script from "./ProWhy3.vue?vue&type=script&lang=js&"
export * from "./ProWhy3.vue?vue&type=script&lang=js&"
import style0 from "./ProWhy3.vue?vue&type=style&index=0&id=2c40aa22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c40aa22",
  null
  
)

export default component.exports